import { FaMapMarkerAlt } from "react-icons/fa";

const getDataFieldsMapData = () => {
  return [
    {
      title: "Point",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "groupByFields",
      itemInArray: true,
    },

    {
      title: "Filters",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      queryKey: "Filters",
      reduxKey: "filters",
      itemInArray: true,
    },
    {
      title: "Tooltip",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "rows",
      itemInArray: true,
    },
  ];
};

const getCustomizationMapData = () => {
  return [
    {
      title: "Color",
      type: "CONDITIONAL_FORMATTING",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "conditionalFormatting",
      itemInArray: true,
      defaultValue: [],
    },
  ];
};
const getCordinatemapChartDetails = () => {
  return {
    chartType: "recharts",
    imageSrc: "/graph_img/Mapchart.png",
    label: "PointsMap",
    value: "cordinatemap",
    icon: <FaMapMarkerAlt className="text-xl text-blue-950" />,
    fileName: "CordinateMap.js",
  };
};

export {
  getCustomizationMapData,
  getDataFieldsMapData,
  getCordinatemapChartDetails,
};
